import * as React from 'react'
import { Button, Paper, Box } from '@mui/material'
import { createEffect, createStore } from 'effector'
import { useStore } from 'effector-react'
import api from '../../Auth/api'
import { BlockTitle } from '../../components/UI/BlockTitle/BlockTitle'
import RecoveryReportTable from '../../components/RecoveryReportTable'

interface RecoveryReportRow {
  id: number
  documentInfo: string
  clientNames: string[]
  account: {
    number: string
    date: string
  }
  isPaid: {
    value: boolean
    label: string
  }
  waitingTime: {
    value: number
    label: string
  }
}

interface RecoveryReportResponse {
  data: {
    rows: RecoveryReportRow[]
  }
}

interface RecoveryReportExportResponse {
  data: {
    bytes: string
  }
}

export const $recoveryReport = createStore<RecoveryReportRow[] | null>(null)

export const getRecoveryReportFx = createEffect(async () => {
  const response = await api.post<RecoveryReportResponse>(`report/recovery`)
  return response
})

export const exportRecoveryReportFx = createEffect(async () => {
  const response = await api.post<RecoveryReportExportResponse>(
    `report/recovery-export`
  )
  return response
})

$recoveryReport.on(getRecoveryReportFx.done, (state, { result }) => {
  return result.data.data.rows
})

const downloadExcel = (
  base64Bytes: string,
  fileName = 'Отчёт для взыскания.xlsx'
) => {
  const link = document.createElement('a')
  link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64Bytes}`
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export default function RecoveryReport() {
  const recoveryReport = useStore($recoveryReport)

  React.useEffect(() => {
    getRecoveryReportFx()
  }, [])

  const handleExport = async () => {
    const result = await exportRecoveryReportFx()
    const base64Bytes = result?.data?.data?.bytes
    if (base64Bytes) {
      downloadExcel(base64Bytes)
    }
  }

  return (
    <Paper sx={{ padding: '1rem', borderRadius: '1rem', mt: 3 }} elevation={0}>
      <Box display="flex" flexDirection="column" gap={2}>
        <BlockTitle backUrl="/reports" label="Отчёт для взыскания" />
        <Box>
          <Button variant="outlined" onClick={handleExport}>
            Экспорт в Excel
          </Button>
        </Box>
        <RecoveryReportTable data={recoveryReport} />
      </Box>
    </Paper>
  )
}
